import * as React from 'react'

import { cn } from '@/lib/utils'

export interface SectionPropsHeader extends React.HTMLAttributes<HTMLDivElement> {
  label?: string
  title: string
  subtitle?: string
  className?: string
  /** Custom inline styles for the title */
  titleStyle?: React.CSSProperties
  /** Custom inline styles for the subtitle */
  subtitleStyle?: React.CSSProperties
}

export default function SectionHeader({
  label,
  title,
  subtitle,
  className,
  titleStyle,
  subtitleStyle,
  ...props
}: SectionPropsHeader) {
  return (
    <div className={cn('flex flex-col items-center text-center', className)} {...props}>
      {label ? <div className="mb-4 font-semibold text-primary">{label}</div> : null}
      <h2 className="text-3xl font-semibold md:text-4xl lg:text-5xl" style={titleStyle}>
        {title}
      </h2>
      {subtitle ? (
        <p
          className="mt-6 text-balance text-lg md:text-xl text-muted-foreground max-w-[46.875rem]"
          style={subtitleStyle}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  )
}
